<script>
export default {
    name: 'IconSort',
}
</script>
<template>
    <svg role="img"
        class="base-icon icon-sort"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M20 44.35L24.414 40 32 47.427 39.586 40 44 44.35 32.1 56l-.1-.098-.1.098L20 44.35zm0-24.543l11.9-11.65.1.098.1-.098L44 19.807l-4.414 4.35L32 16.73l-7.585 7.426L20 19.807z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
